import React, { useEffect, useState } from "react";
import "../css/Reserva.css";
import HeaderSecundario from "../components/HeaderSecundario.js";
import M from "materialize-css";
import $ from "jquery";

export default function Reserva(props) {
  const [instanciaModal, setInstanciaModal] = useState(null);
  const [instanciaModalCargando, setInstanciaModalCargando] = useState(null);

  const [numTarjeta, setNumTarjeta] = useState("");
  const [montoReserva, setMontoReserva] = useState("");
  const [tarjetas, setTarjetas] = useState([]);
  const [nombre, setNombre] = useState("");
  const [mesVencimiento, setMesVencimiento] = useState("");
  const [anioVencimiento, setAnioVencimiento] = useState("");
  const [codSeg, setCodSeg] = useState("");
  const [numDocumento, setNumDocumento] = useState("");
  const [dirEmail, setDirEmail] = useState("");
  const [confDirEmail, setConfDirEmail] = useState("");
  const [codArea, setCodArea] = useState("");
  const [telefono, setTelefono] = useState("");
  const [idTarjeta, setIdTarjeta] = useState("seleccion");

  const [errorMontoReserva, setErrorMontoReserva] = useState("");
  const [errorNumTarjeta, setErrorNumTarjeta] = useState("");
  const [errorNombre, setErrorNombre] = useState("");
  const [errorVencimientoMes, setErrorVencimientoMes] = useState("");
  const [errorVencimientoAnio, setErrorVencimientoAnio] = useState("");
  const [errorNumDocumento, setErrorNumDocumento] = useState("");
  const [errorCodSeg, setErrorCodSeg] = useState("");
  const [errorDirEmail, setErrorDirEmail] = useState("");
  const [errorConfDirEmail, setErrorConfDirEmail] = useState("");
  const [errorCodArea, setErrorCodArea] = useState("");
  const [errorTelefono, setErrorTelefono] = useState("");

  const [cantErrores, setCantErrores] = useState(0);

  /*  const pol_0km =
    props.descuentos &&
    props.descuentos.descuentos &&
    props.descuentos.descuentos[0].Pol_0km;
  const pol_0km_Gastos =
    props.descuentos &&
    props.descuentos.descuentos &&
    props.descuentos.descuentos[0].Pol_0km_Gastos; */
  /*   const pol_Usados = props.descuentos.descuentos[0].Pol_Usados;
  const pol_Usados_Gastos = props.descuentos.descuentos[0].Pol_Usados_Gastos; */

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 1300) {
      $(".formAuto").addClass("posicionUno");
    }
  });

  function formValido() {
    var cantErrores = 0;

    if (idTarjeta == "seleccion") {
      cantErrores++;

      $("#tarjeta").css("border", "1px solid red");
    } else {
      $.map($(".msg-error"), (error) => {
        if (error.innerHTML != "") {
          cantErrores++;
        }
      });
    }

    return cantErrores == 0;
  }

  const handleSubmit = (event) => {
    props.onHandleReservar(null);
    event.preventDefault();

    if (formValido()) {
      var params = {
        unidad: props.vehiculo.id,
        num_tarjeta: numTarjeta,
        method_id: idTarjeta,
        cod_seguridad: codSeg,
        expirationmonth: mesVencimiento,
        expirationyear: anioVencimiento,
        titular: nombre,
        tipo_documento: "DNI",
        num_documento: numDocumento,
        mail: dirEmail,
        moneda: props.vehiculo.moneda,
        precio: montoReserva,
        telefono: codArea + telefono,
        patentamiento:
          props.gastos.patentamiento === 0 ? "Con nosotros" : "Por su cuenta",
      };

      instanciaModalCargando.open();

      var datajson;

      $.post("https://store.autoprana.com.ar/vtf/procesar.php", params)
        .done(function (data) {
          console.log("Ocultar loading...");
          instanciaModalCargando.close();

          datajson = $.parseJSON(data);

          if (datajson.result == 1) {
            props.onHandleReservar(1);
            props.onHandleComprobante(datajson.dec);
          } else {
            props.onHandleReservar(2);
          }
        })
        .fail(function () {
          console.log("Ocultar loading...");

          alert("todo mal con la red");
        });
    } else {
      console.log("hay errores");
    }
  };

  var instanceModal;

  useEffect(() => {
    var url = "https://store.autoprana.com.ar/pranaapi/tarjetas";

    fetch(url)
      .then((data) => {
        return data.json();
      })
      .then((tarjetas) => {
        var itemsTarjetas = [];

        tarjetas.data.map((tarjeta) => {
          itemsTarjetas.push(
            <option key={tarjeta.id} value={tarjeta.id}>
              {tarjeta.tarjeta}
            </option>
          );
        });

        setTarjetas(itemsTarjetas);

        var elems = document.querySelectorAll("select");
        var instances = M.FormSelect.init(elems, { dropdownOptions: {} });
      });
  }, []);

  useEffect(() => {
    $("#noCopy").on("cut copy paste", function (e) {
      e.preventDefault();
    });
    $("form").attr("autocomplete", "off");
  }, []);

  useEffect(() => {
    var elem = document.getElementById("modal-condiciones");
    setInstanciaModal(M.Modal.init(elem));

    $("#checkBox").change(handleOnChangeAccept);
  }, []);

  useEffect(() => {
    var modalCargando = document.getElementById("modal-cargando");
    setInstanciaModalCargando(M.Modal.init(modalCargando));
  }, []);

  const handleOnChangeAccept = () => {
    if ($("#checkBox").is(":checked")) {
      $("#botonReservar").removeClass("disabled").addClass("red accent-4");
    } else {
      $("#botonReservar").removeClass("red accent-4").addClass("disabled");
    }
  };

  const scrollTop = () => {
    window.scroll({
      top: 0,
    });
  };

  const handleAccept = () => {
    $("#checkBox").prop("checked", "true").change();
    $("#botonReservar").removeClass("disabled").addClass("red accent-4");

    instanciaModal.close();
  };

  const handleReservaChange = (event) => {
    var patronEnterosPositivos = /^\d*$/; //Expresión regular para aceptar solo números enteros

    var montoIngresado;

    if (patronEnterosPositivos.test(event.target.value)) {
      montoIngresado = Number(event.target.value);

      if (montoIngresado == 0) {
        montoIngresado = "";
      }

      setMontoReserva(montoIngresado);
    }
  };

  const handleReservaBlur = (event) => {
    if (
      montoReserva < props.vehiculo.reserva_min ||
      montoReserva > props.vehiculo.reserva_min + 200000
    ) {
      setErrorMontoReserva(
        `La reserva debe ser de ${Intl.NumberFormat("es-AR", {
          style: "currency",
          currency: "ARS",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(
          props.vehiculo.reserva_min
        )} o mayor y menor o igual que ${Intl.NumberFormat("es-AR", {
          style: "currency",
          currency: "ARS",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(props.vehiculo.reserva_min + 200000)}`
      );

      setMontoReserva(props.vehiculo.reserva_min);
    } else if (
      montoReserva >= props.vehiculo.reserva_min + 1 ||
      montoReserva <= props.vehiculo.reserva_min + 200000
    ) {
      setErrorMontoReserva("");
    }
  };

  const handleIdTarjetaChange = (event) => {
    setIdTarjeta(event.target.value);

    $("#tarjeta").css("border", "none");
  };

  const handleTarjetaChange = (event) => {
    var patronEnterosPositivos = /^\d*$/; //Expresión regular para aceptar solo números enteros
    var numTarjetaIngresado;

    if (patronEnterosPositivos.test(event.target.value)) {
      numTarjetaIngresado = Number(event.target.value);

      setNumTarjeta("" + numTarjetaIngresado);
    }
  };

  const handleNumTarjetaBlur = (event) => {
    if (numTarjeta.length < 13) {
      setErrorNumTarjeta("La tarjeta debe contener al menos 13 caracteres");
    } else {
      setErrorNumTarjeta("");
    }
  };

  const handleNombreChange = (event) => {
    var patronLetras = /^[a-zA-Z\s]*$/; //matches one letter from A–Z in lowercase and uppercase
    var nombreIngresado;

    if (patronLetras.test(event.target.value)) {
      nombreIngresado = event.target.value;

      setNombre(nombreIngresado);
    }
  };

  const handleNombreBlur = (event) => {
    if (nombre.length < 6) {
      setErrorNombre("Ingrese un nombre valido");
    } else {
      setErrorNombre("");
    }
  };

  const handleMesVencimientoChange = (event) => {
    var patronEnterosPositivos = /^\d*$/; //Expresión regular para aceptar solo números enteros

    var mesIngresado;

    if (patronEnterosPositivos.test(event.target.value)) {
      mesIngresado = event.target.value;

      setMesVencimiento(mesIngresado);
    }
  };

  const handleMesVencimientoBlur = (event) => {
    var mes = parseInt(mesVencimiento);

    if (mes == 0 || mes > 12 || mesVencimiento == "") {
      setErrorVencimientoMes("Ingrese un mes valido");
    } else {
      setErrorVencimientoMes("");

      if (anioVencimiento != "") {
        if (validarFechaVencimiento()) {
          setErrorVencimientoMes("");
        } else {
          if (errorVencimientoAnio != "La fecha no es valida") {
            setErrorVencimientoMes("La fecha no es valida");

            if (errorVencimientoAnio == "La fecha no es valida") {
              setErrorVencimientoAnio("");
            }
          } else {
            setErrorVencimientoMes("");
          }
        }
      }

      if (mes <= 9 && ("" + mes).length == 1) {
        setMesVencimiento("0" + mes);
      }
    }
  };

  //EJEMPLO = HOY ES 07/20, hoy es 01/23

  //CASO 1= El mes de vencimiento es menor que el mes actual

  //    EJ 1= 05/20           EJ2= 05/25

  // Si el mes de vencimiento es menor que el mes actual,
  //el año debe ser mayor que el actual

  //CASO 2= El mes de vencimiento es mayor o igual que el mes actual

  //    EJ 1= 08/20   EJ 2= 07/20 => El año debe ser mayor o igual

  function validarFechaVencimiento() {
    var fechaValida = true;

    var current_date = new Date();

    var anioActual = current_date.getYear() - 100;
    var mesActual = current_date.getMonth() + 1;

    if (mesVencimiento < mesActual) {
      if (anioVencimiento <= anioActual) {
        fechaValida = false;
      }
    } else {
      if (anioVencimiento < mesActual) {
        fechaValida = false;
      }
    }

    return fechaValida;
  }

  const handleAnioVencimientoChange = (event) => {
    var patronEnterosPositivos = /^\d*$/; //Expresión regular para aceptar solo números enteros

    var anioIngresado;

    if (patronEnterosPositivos.test(event.target.value)) {
      anioIngresado = event.target.value;

      setAnioVencimiento(anioIngresado);
    }
  };

  const handleAnioVencimientoBlur = (event) => {
    var current_date = new Date();
    var getYear = current_date.getYear() - 100;

    console.log(getYear);

    if (anioVencimiento > getYear + 20 || anioVencimiento < getYear) {
      setErrorVencimientoAnio("Ingrese un vencimiento valido");
    } else {
      if (validarFechaVencimiento()) {
        setErrorVencimientoAnio("");

        if (errorVencimientoMes == "La fecha no es valida") {
          setErrorVencimientoMes("");
        }
      } else {
        if (errorVencimientoMes != "La fecha no es valida") {
          setErrorVencimientoAnio("La fecha no es valida");
        } else {
          setErrorVencimientoAnio("");
        }
      }
    }
  };

  const handleCodigoChange = (event) => {
    var patronEnterosPositivos = /^\d*$/; //Expresión regular para aceptar solo números enteros

    var codIngresado;

    if (patronEnterosPositivos.test(event.target.value)) {
      codIngresado = event.target.value;

      setCodSeg("" + codIngresado);
    }
  };

  const handleCodigoBlur = (event) => {
    if (codSeg.length < 3 || codSeg == "") {
      setErrorCodSeg("Ingrese el codigo de seguridad");
    } else {
      setErrorCodSeg("");
    }
  };

  const handleNumDocumentoChange = (event) => {
    var patronEnterosPositivos = /^\d*$/; //Expresión regular para aceptar solo números enteros

    var docIngresado;

    if (patronEnterosPositivos.test(event.target.value)) {
      docIngresado = event.target.value;

      setNumDocumento("" + docIngresado);
    }
  };

  const handleNumDocumentoBlur = (event) => {
    if (numDocumento.length < 8) {
      setErrorNumDocumento("Ingrese un numero valido");
    } else {
      setErrorNumDocumento("");
    }
  };

  const handleDirEmailChange = (event) => {
    var emailIngresado;

    emailIngresado = event.target.value;
    setDirEmail(emailIngresado);
  };

  const handleDirEmailBlur = (event) => {
    var patronEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //Expresión regular para aceptar direcciones de correo electronicos

    patronEmail.test(dirEmail);

    if (patronEmail.test(dirEmail) == false) {
      setErrorDirEmail("Ingrese un correo electronico valido");
    } else {
      setErrorDirEmail("");
    }
  };

  const handleConfDirEmailChange = (event) => {
    var emailIngresado;

    emailIngresado = event.target.value;
    setConfDirEmail(emailIngresado);
  };

  const handleConfDirEmailBlur = (event) => {
    var patronEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //Expresión regular para aceptar direcciones de correo electronicos

    patronEmail.test(confDirEmail);

    if (
      (patronEmail.test(confDirEmail) == false && confDirEmail != dirEmail) ||
      (patronEmail.test(confDirEmail) == true && confDirEmail != dirEmail)
    ) {
      setErrorConfDirEmail("Ingrese un correo electronico valido");
    } else {
      setErrorConfDirEmail("");
    }
  };

  const handleCodAreaChange = (event) => {
    var patronEnterosPositivos = /^\d*$/; // /^(?:((?P<p1>(?:\( ?)?+)(?:\+|00)?(54)(?<p2>(?: ?\))?+)(?P<sep>(?:[-.]| (?:[-.] )?)?+)(?:(?&p1)(9)(?&p2)(?&sep))?|(?&p1)(0)(?&p2)(?&sep))?+(?&p1)(11|([23]\d{2}(\d)??|(?(-10)(?(-5)(?!)|[68]\d{2})|(?!))))(?&p2)(?&sep)(?(-5)|(?&p1)(15)(?&p2)(?&sep))?(?:([3-6])(?&sep)|([12789]))(\d(?(-5)|\d(?(-6)|\d)))(?&sep)(\d{4})|(1\d{2}|911))$/D

    var areaIngresada;

    if (patronEnterosPositivos.test(event.target.value)) {
      areaIngresada = event.target.value;

      setCodArea("" + areaIngresada);
    }
  };

  const handleCodAreaBlur = (event) => {
    if (codArea == "") {
      setErrorCodArea("Ingrese un codigo de area");
    } else {
      setErrorCodArea("");
    }
  };

  const handleTelefonoChange = (event) => {
    var patronEnterosPositivos = /^\d*$/; // /^(?:((?P<p1>(?:\( ?)?+)(?:\+|00)?(54)(?<p2>(?: ?\))?+)(?P<sep>(?:[-.]| (?:[-.] )?)?+)(?:(?&p1)(9)(?&p2)(?&sep))?|(?&p1)(0)(?&p2)(?&sep))?+(?&p1)(11|([23]\d{2}(\d)??|(?(-10)(?(-5)(?!)|[68]\d{2})|(?!))))(?&p2)(?&sep)(?(-5)|(?&p1)(15)(?&p2)(?&sep))?(?:([3-6])(?&sep)|([12789]))(\d(?(-5)|\d(?(-6)|\d)))(?&sep)(\d{4})|(1\d{2}|911))$/D

    var telefonoIngresado;

    if (patronEnterosPositivos.test(event.target.value)) {
      telefonoIngresado = event.target.value;

      setTelefono("" + telefonoIngresado);
    }
  };

  const handleTelefonoBlur = (event) => {
    if (telefono == "") {
      setErrorTelefono("Ingrese un telefono");
    } else {
      setErrorTelefono("");
    }
  };

  const rutaImg =
    "https://store.autoprana.com.ar/img/logos/" +
    props.vehiculo.modelo.toLowerCase() +
    ".png";

  const img = "https://store.autoprana.com.ar/img/";

  return (
    <div>
      <HeaderSecundario
        modelos={props.modelos}
        handleMostrarModal={props.handleMostrarModal}
      />

      <div className="row contenedorReserva">
        <div className="col s12 m12 l7 formDatos">
          <form onSubmit={handleSubmit}>
            <div className="col s12 m8 l8" style={{ paddingLeft: "5%" }}>
              <p>
                <span style={{ fontFamily: "Toyota_Bold", fontSize: "20px" }}>
                  ¡Estás a un paso de que sea tuyo!
                </span>
                <br />
                <span
                  style={{ fontFamily: "Toyota_Regular", fontSize: "16px" }}
                >
                  Ingresa tu reserva.
                </span>
                <br />
                <span
                  style={{ fontFamily: "Toyota_Regular", fontSize: "16px" }}
                >
                  Recordá que el monto mínimo es de{" "}
                  {Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }).format(props.vehiculo.reserva_min)}
                </span>
                <br />
              </p>
            </div>

            <div
              className="col s11 m11 l11"
              style={{
                marginLeft: "5%",
                border: "1px solid #e0e0e0",
                paddingBottom: "2%",
                paddingTop: "2%",
              }}
            >
              <span style={{ fontFamily: "Toyota_Bold", fontSize: "17px" }}>
                ¿Con cuanto reservas?
              </span>
              <br />
              <br />
              <label className="etiqueta">Monto de la reserva</label>
              <div className="row">
                <div className="input-field col s12 m6 l6">
                  <i className="material-icons prefix">attach_money</i>
                  <input
                    required
                    id="targetMonto"
                    maxLength="10"
                    value={montoReserva}
                    onBlur={handleReservaBlur}
                    onChange={handleReservaChange}
                    name="monto"
                    placeholder="Ingrese el importe"
                  />
                </div>

                <div
                  className="col s12 m12 l12"
                  style={{ color: "red", fontFamily: "Toyota_Regular" }}
                >
                  {errorMontoReserva}
                </div>
              </div>
            </div>

            <div
              className="col s8 m8 l8"
              style={{ marginLeft: "5%", marginTop: "3%" }}
            >
              <p>
                <span style={{ fontFamily: "Toyota_Bold", fontSize: "20px" }}>
                  Datos de Pago
                </span>
                <br />
              </p>
            </div>

            <div
              className="col s11 m11 l11"
              style={{
                marginLeft: "5%",
                border: "1px solid #e0e0e0",
                paddingBottom: "2%",
                paddingTop: "2%",
              }}
            >
              <span style={{ fontFamily: "Toyota_Bold", fontSize: "17px" }}>
                Datos de la Tarjeta
              </span>
              <br />
              <br />
              <label className="etiqueta">Tarjeta</label>
              <div className="row">
                <div id="tarjeta" className="col s12 m6 l6">
                  <select
                    name="tarjeta"
                    value={idTarjeta}
                    onChange={handleIdTarjetaChange}
                    required
                  >
                    <option value="seleccion" key="selected" disabled>
                      Selecciona tu tarjeta...
                    </option>
                    {tarjetas}
                  </select>
                </div>
              </div>
              <br />
              <label className="etiqueta">Numero de la tarjeta</label>
              <div className="row">
                <div className="input-field col s12 m6 l6">
                  <i className="material-icons prefix">credit_card</i>
                  <input
                    required
                    id="targetTarjeta"
                    value={numTarjeta}
                    onBlur={handleNumTarjetaBlur}
                    name="tarjeta"
                    placeholder="Ingrese el numero de la tarjeta"
                    onChange={handleTarjetaChange}
                    maxLength="18"
                  />
                </div>
                <div
                  className="msg-error col s12 m12 l12"
                  style={{ color: "red", fontFamily: "Toyota_Regular" }}
                >
                  {errorNumTarjeta}
                </div>
              </div>
              <br />
              <label className="etiqueta">Titular de la tarjeta</label>
              <div className="row">
                <div className="input-field col s12 m6 l6">
                  <i className="material-icons prefix">perm_identity</i>
                  <input
                    required
                    name="titularTarjeta"
                    value={nombre}
                    onBlur={handleNombreBlur}
                    placeholder="Como figura en la tarjeta"
                    onChange={handleNombreChange}
                    maxLength="40"
                  />
                </div>
                <div
                  className="msg-error col s12 m12 l12"
                  style={{ color: "red", fontFamily: "Toyota_Regular" }}
                >
                  {errorNombre}
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col s12 m6 l6">
                  <div className="col s6 m6 l6">
                    <label className="etiqueta">Fecha vencimiento</label>

                    <div className="col s6 m6 l6">
                      <input
                        required
                        name="mesVencimiento"
                        value={mesVencimiento}
                        onBlur={handleMesVencimientoBlur}
                        onChange={handleMesVencimientoChange}
                        placeholder="00"
                        maxLength="2"
                      />
                      /
                    </div>
                    <div className="col s6 m6 l6">
                      <input
                        required
                        name="anioVencimiento"
                        value={anioVencimiento}
                        onBlur={handleAnioVencimientoBlur}
                        onChange={handleAnioVencimientoChange}
                        placeholder="00"
                        maxLength="2"
                      />
                    </div>
                  </div>

                  <div className="col s6 m6 l6">
                    <label className="etiqueta">Codigo de seguridad</label>
                    <input
                      required
                      name="codigoSeguridad"
                      value={codSeg}
                      onBlur={handleCodigoBlur}
                      onChange={handleCodigoChange}
                      placeholder="000"
                      maxLength="7"
                    />
                  </div>

                  <div
                    className="msg-error col s12 m12 l12"
                    style={{ color: "red", fontFamily: "Toyota_Regular" }}
                  >
                    {errorVencimientoMes.length > 0 && (
                      <div>
                        {" "}
                        {errorVencimientoMes}
                        <br />
                      </div>
                    )}
                    {errorVencimientoAnio.length > 0 && (
                      <div>
                        {" "}
                        {errorVencimientoAnio}
                        <br />
                      </div>
                    )}
                    {errorCodSeg.length > 0 && (
                      <div>
                        {" "}
                        {errorCodSeg}
                        <br />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <label className="etiqueta">Numero de documento</label>
              <div className="row">
                <div className="input-field col s12 m6 l6">
                  <i className="material-icons prefix">import_contacts</i>
                  <input
                    required
                    name="documento"
                    value={numDocumento}
                    onChange={handleNumDocumentoChange}
                    onBlur={handleNumDocumentoBlur}
                    placeholder="Ej.:30891632"
                    maxLength="9"
                  />
                </div>

                <div
                  className="msg-error col s12 m12 l12"
                  style={{ color: "red", fontFamily: "Toyota_Regular" }}
                >
                  {errorNumDocumento}
                </div>
              </div>
              <br />
            </div>

            <div
              className="col s8 m8 l8"
              style={{ marginLeft: "5%", marginTop: "3%" }}
            >
              <p>
                <span style={{ fontFamily: "Toyota_Bold", fontSize: "20px" }}>
                  Datos de Contacto
                </span>
                <br />
              </p>
            </div>

            <div
              className="col s11 m11 l11"
              style={{
                marginLeft: "5%",
                border: "1px solid #e0e0e0",
                paddingBottom: "2%",
                paddingTop: "2%",
              }}
            >
              <span style={{ fontFamily: "Toyota_Bold", fontSize: "17px" }}>
                Datos para envio de reserva:
              </span>
              <br />
              <br />
              <label className="etiqueta">E-mail</label>
              <div className="row">
                <div className="input-field col s12 m6 l6">
                  <i className="material-icons prefix">email</i>
                  <input
                    required
                    name="correo"
                    value={dirEmail}
                    onChange={handleDirEmailChange}
                    onBlur={handleDirEmailBlur}
                    placeholder="Ingresa un e-mail de contacto"
                    maxLength="60"
                  />
                </div>
                <div
                  className="msg-error col s12 m12 l12"
                  style={{ color: "red", fontFamily: "Toyota_Regular" }}
                >
                  {errorDirEmail}
                </div>
              </div>
              <br />
              <label className="etiqueta">Confirma tu e-mail</label>
              <div className="row">
                <div className="input-field col s12 m6 l6">
                  <i className="material-icons prefix">drafts</i>
                  <input
                    required
                    name="reCorreo"
                    id="noCopy"
                    onChange={handleConfDirEmailChange}
                    onBlur={handleConfDirEmailBlur}
                    placeholder="Re-ingresa tu e-mail de contacto"
                  />
                </div>
                <div
                  className="msg-error col s12 m12 l12"
                  style={{ color: "red", fontFamily: "Toyota_Regular" }}
                >
                  {errorConfDirEmail}
                </div>
              </div>
            </div>

            <div
              className="col s11 m11 l11"
              style={{
                marginLeft: "5%",
                border: "1px solid #e0e0e0",
                paddingBottom: "2%",
                paddingTop: "2%",
                marginTop: "5%",
              }}
            >
              <span style={{ fontFamily: "Toyota_Bold", fontSize: "17px" }}>
                Telefono de contacto:
              </span>
              <br />
              <br />

              <label className="etiqueta" style={{ marginLeft: "7%" }}>
                Area
              </label>
              <label className="etiqueta" style={{ marginLeft: "7%" }}>
                Numero
              </label>
              <div className="row">
                <div className="input-field col s4 m2 l2">
                  <i className="material-icons prefix">phone</i>
                  <input
                    required
                    name="area"
                    value={codArea}
                    onChange={handleCodAreaChange}
                    onBlur={handleCodAreaBlur}
                    placeholder="11"
                    maxLength="6"
                  />
                </div>
                <div className="input-field col s8 m4 l4">
                  <input
                    required
                    name="telefono"
                    value={telefono}
                    onChange={handleTelefonoChange}
                    onBlur={handleTelefonoBlur}
                    placeholder="Ingresa un numero"
                    maxLength="12"
                  />
                </div>
                <div
                  className="msg-error col s12 m12 l12"
                  style={{ color: "red", fontFamily: "Toyota_Regular" }}
                >
                  {errorCodArea}
                </div>
                <div
                  className="msg-error col s12 m12 l12"
                  style={{ color: "red", fontFamily: "Toyota_Regular" }}
                >
                  {errorTelefono}
                </div>
              </div>
            </div>

            <div
              className="col s11 m11 l11 center-align"
              style={{
                marginLeft: "5%",
                paddingBottom: "2%",
                paddingTop: "2%",
                marginTop: "3.5%",
              }}
            >
              <label>
                <input required name="checkbox" type="checkbox" id="checkBox" />
                <span style={{ color: "black" }}>
                  <a
                    className="modal-trigger"
                    href="#modal-condiciones"
                    style={{ color: "black", fontFamily: "Toyota_Regular" }}
                  >
                    Lei y acepto las condiciones de compra y políticas de
                    privacidad <br />
                    (click aqui)
                  </a>
                </span>
              </label>

              <div className="row">
                <input
                  type="submit"
                  className="btn waves-effect hoverable white-text disabled"
                  id="botonReservar"
                  onClick={scrollTop}
                  style={{ marginTop: "3%", marginLeft: "4%" }}
                  value="Reservar"
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col s12 m12 l5 formAuto">
          <div
            className="col s11 m11 l11"
            style={{
              border: "1px solid #e0e0e0",
              paddingBottom: "2%",
              paddingTop: "4%",
              marginTop: "3%",
              paddingLeft: "5%",
            }}
          >
            <span style={{ fontFamily: "Toyota_Bold", fontSize: "17px" }}>
              Detalle de la Reserva
            </span>
            <br />
            <br />
            <div className="col s12 m12 l12">
              <span style={{ fontFamily: "Toyota_Regular", fontSize: "15px" }}>
                Vehiculo que estas reservando:
              </span>
              <div className="row">
                <div className="col s12 m3 l3">
                  <div className="row valign-wrapper">
                    <img className="miniaturaLogo" src={rutaImg} />
                  </div>
                </div>
                <div className="col s12 m8 l8">
                  <img
                    className="responsive-img fotoVehiculoReserva"
                    src={img + props.vehiculo.foto0}
                    alt="vehiculo seleccionado"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="col s11 m11 l11"
            style={{
              border: "1px solid #e0e0e0",
              paddingBottom: "2%",
              paddingTop: "4%",
              paddingLeft: "5%",
            }}
          >
            <div className="col s12 m12 l12">
              <div className="row">
                <div className="col s12 m7 l7" style={{ marginBottom: "3%" }}>
                  <span
                    style={{ fontFamily: "Toyota_Regular", fontSize: "15px" }}
                  >
                    Valor del Vehiculo
                  </span>
                </div>
                <div className="col s12 m4 l4">
                  <span
                    style={{ fontFamily: "Toyota_Regular", fontSize: "15px" }}
                  >
                    &nbsp;&nbsp;
                    {props.vehiculo.moneda}
                    {Intl.NumberFormat("es-AR", {
                      currency: "ARS",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }).format(props.vehiculo.precio)}
                  </span>
                </div>
                {/*  <div className="col s12 m7 l7">
                  <span
                    style={{
                      fontFamily: "Toyota_Bold",
                      fontSize: "15px",
                      color: "red",
                    }}
                  >
                    DESCUENTO
                  </span>
                </div> */}
                {/*  <div className="col s12 m4 l4">
                  <span
                    style={{
                      fontFamily: "Toyota_Bold",
                      fontSize: "15px",
                      color: "red",
                    }}
                  >
                    -{" "}
                    {props.gastos.patentamiento === 0
                      ? Intl.NumberFormat("es-AR", {
                          style: "currency",
                          currency: "ARS",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        }).format(
                          props.vehiculo.precio * pol_0km +
                            props.vehiculo.pat_emp * pol_0km_Gastos
                        )
                      : Intl.NumberFormat("es-AR", {
                          style: "currency",
                          currency: "ARS",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        }).format(props.vehiculo.precio * pol_0km)}
                  </span>
                </div> */}
                <div className="col s12 m7 l7">
                  <span
                    style={{ fontFamily: "Toyota_Regular", fontSize: "15px" }}
                  >
                    Valor del Patentamiento
                  </span>
                </div>
                <div className="col s12 m4 l4">
                  <span
                    style={{ fontFamily: "Toyota_Regular", fontSize: "15px" }}
                  >
                    &nbsp;&nbsp;&nbsp;
                    {Intl.NumberFormat("es-AR", {
                      style: "currency",
                      currency: "ARS",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }).format(props.gastos.total_pat)}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col s11 m11 l11"
            style={{
              border: "1px solid #e0e0e0",
              paddingTop: "4%",
              paddingLeft: "5%",
              paddingBottom: "4%",
            }}
          >
            <div className="col s12 m7 l7">
              <span style={{ fontFamily: "Toyota_Bold", fontSize: "17px" }}>
                Total
              </span>
              <br />
              <br />
            </div>
            <div className="col s12 m4 l4">
              <span style={{ fontFamily: "Toyota_Bold", fontSize: "17px" }}>
                {props.gastos.total}
              </span>
            </div>
          </div>
          <div
            className="col s11 m11 l11 valign-wrapper"
            style={{ background: "#ec1c24", height: "30px" }}
          >
            <div
              style={{ padding: "7%", margin: "0" }}
              className="col s12 m7 l7"
            >
              <span style={{ color: "white", fontFamily: "Toyota_Bold" }}>
                MONTO RESERVA
              </span>
            </div>
            <div
              style={{ padding: "4%", margin: "0" }}
              className="col s12 m4 l4"
            >
              <span style={{ color: "white", fontFamily: "Toyota_Bold" }}>
                {Intl.NumberFormat("es-AR", {
                  style: "currency",
                  currency: "ARS",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(montoReserva)}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div id="modal-condiciones" className="modal">
        <div className="modal-content left-align">
          <h4>Terminos y condiciones</h4>
          <p>
            1- PEDIDO: La presente SOLICITUD DE RESERVA tiene el caracter de
            irrevocable e instransferible y la firma vendedora ser reserva la
            facultad de aceptarla o rechazarla en cualquier momento sin
            limitacion alguna entendiendose concretada la compra recien en el
            momento de entrega de la unidad y en el caso de que el comprador
            desistiese de la compra todo deposito efectuado en aplicacion a la
            misma quedara definitiva y automaticamente en poder de la firma
            vendedora como indemnizacion a excepcion de los casos previstos en
            los arts. 2do y 3ro. Los valores recibidos constituiran seña una
            recien cuando se emita recibo oficial.
            <br />
            2- PRECIO: Los precios de ventas consignados para la unidad y
            accesorios son los de la lista al publico actuales fijados por
            TOYOTA ARGENTINA S.A. y al igual que las condiciones de pagos
            propuestas, podran variarse en cualquier momento y sin previo aviso,
            rigiendo en este caso y para esta solicitud los nuevos precios de
            venta. En el caso de producirse esta eventualidad el comprador
            tendra derecho a anular su pedido y solicitar por nota el reintegro
            de los depositos efectuados dentro de los quince (15) dias
            subsiguientes a la fecha de variacion, los cuales seran puestos a
            disposicion en un plazo no mayor de treinta (30) dias, sin
            indemnizacion alguna.
            <br />
            3- FECHA DE ENTREGA: La fecha de entrega indicada es meramente
            informativa y no compromete a la firma vendedora a su cumplimiento
            cuando se originen atrasos en los despachos de fabrica,
            inconvenientes en los transportes, huelgas u otras causas de fuerza
            mayor, y toda otra circunstancia equivalente. Pasados noventa (90)
            dias de esa fecha, el comprador podra dentro de los quince (15) dias
            subsiguientes, dejar sin efecto su pedidos con derecho a reintegro
            de todo deposito efectuado, sin indemnizacion alguna. Vencido este
            termino, el mismo quedara prorrogado automaticamente por un nuevo
            periodo.
            <br />
            4- ESPECIFICACIONES: TOYOTA ARGENTINA S.A. se reserva el pleno
            derecho de cancelar la produccion, revisar, suspender o alterar las
            especificaciones tecnicas de sus vehiculos o cualquier pieza de los
            mismos en cualquier momento y sin previo aviso, sin que la fabrica
            ni la firma vendedora asuma la responsabilidad o compromiso alguno
            con el comprador, no estando tampoco obligada a aplicar a las
            unidades ya construidas o en proceso de construccion, las
            modificaciones que hubiesen sido proyectadas al recibo de esta
            solicitud.
            <br />
            5- FINANCIACION: En las operaciones en que se convenga acordar
            facilidades para el pago del precio de venta, el comprador se obliga
            a gravar la unidad adquirida con garantia prendaria en primer grado
            por el saldo del precio mas los gastos de financiacion a favor del
            vendedor o entidad financiera, en su caso. A los efectos de
            considerar la respectiva SOLICITUD DE CREDITO, la firma vendedora
            queda autorizada a recabar informes comerciales, bancarios,
            particulares, etc., que estima necesarios y en caso de proceder a su
            rechazo o comprobar falsedad en los datos suministrados, retendra de
            todo deposito realizado, los gastos incurridos.
            <br />
            6- SEGURO: En las operaciones financiadas el comprador queda
            obligado a contratar una poliza de seguro por ante la compañia
            aseguradora que designe la firma vendedora o entidad financiera,
            contra todo riesgo, inclusive huelgas, hechos belicos, tumultos,
            inundaciones, terremotos y granizos y mantener vigente dicha poliza
            por todo el periodo de la financiacion. En el acto de tomar posesion
            del bien adquirido, el comprador debera entregar a la firma
            vendedora el original de la poliza debidamente endosada,
            conjuntamente con el recibo oficial que justifique el pago total de
            la prima.
            <br />
            7- ENTREGA: El comprador debera retirar y abonar totalmente la
            unidad adquirida y los gastos correspondientes dentro de los diez
            (10) dias desde la comunicacion respectiva. Vencido dicho termino y
            por el solo transcurso del tiempo y sujeto a lo dispuesto en el art.
            1ro para el supuesto de anulacion por parte del comprador.
            <br />
            8- UNIDAD USADA: El valor de toda unidad usada ofrecida como parte
            de pago sera acreditado por la firma vendedora unicamente en caso de
            recibir la misma dentro de las venticuatro (24) horas subsiguientes
            de haberse formalizado el respectivo pedido por la unidad nueva,
            caso contrario el peritaje efectuado tiene caracter "INFORMATIVO", y
            sujeto a una revalidacion, siendo en este caso facultad privativa
            del vendedor aceptar o rechazar la unidad usada. Al valor convenido
            se deducira el impuesto a la transferencia de Automoviles Usados
            (Ley 21.432).
            <br />
            9- Todos los pagos que demande el transporte de la unidad, gastos e
            impuestos por patentamiento y la constitucion de prenda, corren por
            exclusiva cuenta del comprador.
            <br />
            10- Cualquier error en las condiciones o en las sumas que figure en
            el presente pedido, en caso de comprobarse posteriormente, se
            ajustaran a su real valor.
            <br />
            11- Cuando la firma vendedora tenga disponible el vehiculo
            solicitado, notificara tal circunstancia al comprador, quien debera
            hacerse presente para formalizar y ajustar las condiciones
            pendientes de la operacion dentro de los tres (3) dias habiles de
            recibila la notificacion, en cado de que el comprador no compareza
            en el plazo indicado o no cumpla con las condiciones pactadas en el
            lapso de dos (2) dias habiles posteriores a la formalizacion de la
            compra perdera el derecho al turno de entrega pasando a una lista de
            espera, sin perjuicio de las demas estipulaciones contractuales
            contenidas en el presente.
            <br />
            12- Los valores recibidos en deposito por la presente solicitud de
            reserva se acreditaran unicamente con la emision del recibo oficial
            correspondiente.
            <br />
            13- En caso de falta de pago del precio por parte del comprador en
            los plazos estipulados, se producira su mora de pleno derecho, la
            caducidad de los plazos pendientes y consecuentemente la rescision
            de la compra celebrada, pudiendo AUTOPRANA S.A. disponer del
            automovil para otro interesado.
          </p>
        </div>
        <div className="modal-footer">
          <a
            className="white red-text"
            id="botonAceptar"
            style={{
              fontFamily: "Toyota_Bold",
              paddingRight: "2%",
              cursor: "pointer",
            }}
            onClick={handleAccept}
          >
            Aceptar
          </a>
          <a
            className="modal-close white red-text"
            id="botonCancelar"
            style={{ fontFamily: "Toyota_Bold", paddingRight: "2%" }}
          >
            Cancelar
          </a>
        </div>
      </div>

      <div id="modal-cargando" className="modal" style={{ width: "50%" }}>
        <div className="modal-content center-align">
          <div style={{ fontFamily: "Toyota_Bold" }}>ENVIANDO SOLICITUD...</div>

          <div id="cargando">
            <div className="preloader-wrapper active">
              <div className="spinner-layer spinner-red-only">
                <div className="circle-clipper left">
                  <div className="circle"></div>
                </div>
                <div className="gap-patch">
                  <div className="circle"></div>
                </div>
                <div className="circle-clipper right">
                  <div className="circle"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
